
import ButtonFavorite from '@/components/button/ButtonFavorite.ts';
import { Component, Mixins } from 'vue-property-decorator';

@Component
export default class ButtonFavoriteHeart extends Mixins(ButtonFavorite) {
}
